import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Page from '@src/components/page';
import BaseSwiper from '@src/components/swiper/base-swiper';
import PageNum from '@src/business-components/page-num';
import Store from './store';
import BackTopFooter from '@src/business-components/backtop-footer';

const styles = require('./index.less');

const Map = ({ store }) => {
  store.use();

  const swiper = () => {
    return (
      <div className={styles.swiper}>
        <BaseSwiper key={store.slidesData.length} store={store.swiperStore}>
          {store.slidesData.map((item, idx) => {
            return (
              <div key={idx} className={styles.slide}>
                {item?.contentList?.map((info, index) => (
                  <React.Fragment key={index}>
                    <div className={cx(styles.img, store.tabIndex === index && styles.imgActive)} style={{ backgroundImage: `url(${info?.mapImg})` }} />
                    <div className={cx(styles.info, store.tabIndex === index && styles.infoActive)}>
                      {/* 标题 */}
                      <div className={styles.title}>{item?.mapTitle}</div>
                      {/* 英文标题 */}
                      {/* <div className={styles.enTitle}>{item?.enTitle}</div> */}
                      {/* 描述 */}
                      <div className={styles.desc} dangerouslySetInnerHTML={{ __html: info.mapDesc }} />
                    </div>
                  </React.Fragment>
                ))}
                {/* <div className={styles.tab}>
                  {item?.contentList?.map((tab, index) => (
                    <div key={index} className={cx(styles.tabItem, index === store.tabIndex && styles.tabActive)} onClick={() => store.changeTab(index)}>
                      <div className={styles.tabInner} style={{ backgroundImage: `url(${tab.mapImg})` }} />
                    </div>
                  ))}
                </div> */}
              </div>
            );
          })}
        </BaseSwiper>
      </div>
    );
  };

  return (
    <Page className={cx(styles.root, 'page-main')}>
      <div className={styles.content}>
        {/* 轮播 */}
        {swiper()}
        {/* 页码和切换按钮 */}
        <PageNum
          loop={store.slidesData?.length > 1}
          className={styles.pageNumAndToggleBtns}
          current={store.swiperStore?.activeIndex + 1}
          total={store.slidesData?.length}
          name="MAP"
          onPrev={store.playPrev}
          onNext={store.playNext}
        />
        {/* 轮播指示器 */}
        <div className={styles.indicator}>
          {store?.slidesData?.map((_, index) => {
            return (
              <div
                key={index}
                className={cx(styles.indicatorItem, { [styles.indicatorActive]: index === store.swiperStore.activeIndex })}
                onClick={() => {
                  store.changeSwiper(index);
                }}
              />
            );
          })}
        </div>
        <BackTopFooter btns={['copyright']} />
      </div>
    </Page>
  );
};

export default wrapStore(Map, Store);
